<template>
  <fixed-header :threshold="100">
    <nav class="menu">
      <div class="menu-wrapper">
        <h1>
          <router-link class="logo-cta" v-bind:to="'/'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 1080">
              <g data-name="Layer 1">
                <path
                  d="M946 54.2A62.8 62.8 0 00839 98.6v734a64.7 64.7 0 01125.6 0v-734a62.9 62.9 0 00-18.4-44.4zm-44.3 87.5a41.2 41.2 0 1141.2-41.2 41.2 41.2 0 01-41.2 41.3z"
                  fill="#f9df41"
                />
                <circle cx="900.5" cy="848.3" r="41.2" />
                <path
                  d="M997.3 389.9h74.4a2 2 0 012 1.9c2 21.4 37.8 37.3 86.8 37.3 49.8 0 84.1-12.6 84.1-30.1 0-19-42.7-26-106.5-33.6-72.2-8.5-137.3-38.6-137.3-107.2 0-74.3 72.8-113.6 157.6-113.6 90.2 0 157.7 53.6 159 122a2 2 0 01-2 2h-75.1a2.1 2.1 0 01-2.1-1.9c-2.2-18.6-36.4-32.4-80.5-32.4-46.2 0-77.8 11.2-77.8 27.4 0 16.8 39.3 25.9 105.8 33.6 68 7.7 137.4 34.3 137.4 105 0 76.5-73.6 118.5-164 118.5-94.4 0-162.6-56.3-164-126.8a2 2 0 012.2-2.1zM1729.8 361.9h-295.7a2.1 2.1 0 00-1.9 2.9c15.7 36.8 56.3 60.1 111.6 60.1 41.6 0 78.3-11.6 94.7-26.8a2 2 0 011.5-.5h84.4a2 2 0 012 2.8c-27.4 70.6-98.2 118.4-184.6 118.4-110.7 0-193.4-80.6-193.4-187S1431 144.5 1541 144.5s192.7 80 192.7 189.2a186.5 186.5 0 01-1.8 26.3 2 2 0 01-2 1.8zm-295-61h213.9a2.1 2.1 0 001.9-3c-15.1-36.8-57.7-59.4-109.6-59.4-51.2 0-92.4 23.3-108 59.4a2.1 2.1 0 001.9 3zM405.6 553.6v353.2a2 2 0 01-2 2.1h-75.8a2 2 0 01-2.1-2v-61.7a2 2 0 00-3.8-1c-27 45-71 73.1-126.5 73.1-98.1 0-172.4-80.6-172.4-187S97.3 543 195.4 543c55.4 0 99.4 28 126.5 73.2a2 2 0 003.8-1v-61.7a2 2 0 012-2h75.8a2 2 0 012 2zm-79.9 176.6c0-48.3-47-84.8-110-84.8S106.4 682 106.4 730.2 152.6 815 215.7 815s110-36.4 110-84.8zM812.3 732c0 106.7-73.6 187.3-172.6 187.3-55.5 0-100.1-28.6-126.7-73.8a2 2 0 00-3.8 1v195.6a2 2 0 01-2 2.1h-76a2 2 0 01-2-2v-487a2 2 0 012-2.2h76a2 2 0 012 2.1v62.3a2 2 0 003.8 1c26.6-45.2 71.2-73.8 126.7-73.8 99 0 172.6 80.7 172.6 187.4zm-82.8 0c0-48.4-47-85-110.1-85s-110.2 36.6-110.2 85 47 85 110.2 85 110.1-36.6 110.1-85zM1372.1 553.6v353.2a2 2 0 01-2 2.1h-75.8a2 2 0 01-2-2v-61.7a2 2 0 00-3.9-1c-27 45-71 73.1-126.5 73.1-98 0-172.4-80.6-172.4-187S1063.8 543 1162 543c55.5 0 99.5 28 126.5 73.2a2 2 0 003.8-1v-61.7a2 2 0 012.1-2h75.8a2 2 0 012 2zm-79.9 176.6c0-48.3-47-84.8-110-84.8S1073 682 1073 730.2s46.3 84.8 109.3 84.8 110-36.4 110-84.8zM1617.9 548.1V672a2 2 0 01-2.1 2c-84.8.6-130.3 31.9-130.3 88.3v144.3a2 2 0 01-2.1 2.1h-77a2 2 0 01-2.1-2v-353a2 2 0 012-2h77a2 2 0 012.2 2v79.5a2 2 0 004 1c28.3-54.4 72.2-87.3 126.2-88.2a2.1 2.1 0 012.2 2.1zM803 146v124a2 2 0 01-2 2c-84.9.6-130.4 31.9-130.4 88.3v144.3a2 2 0 01-2 2.1h-77a2 2 0 01-2.2-2v-353a2 2 0 012.1-2h77a2 2 0 012.1 2v79.5a2 2 0 004 1c28.3-54.4 72.2-87.3 126.3-88.2a2.1 2.1 0 012.1 2zM1793.8 646.5a2 2 0 00-2.1 2.1v121c0 24.2 15 35.6 46.2 35.6h49.9a2 2 0 012 2.1v98.3a2 2 0 01-2 2.1h-59.1c-78.3 0-118.9-37.7-118.9-113.1v-146a2 2 0 00-2-2.1h-66.4a2 2 0 01-2-2.1v-97.5a2 2 0 012-2.1h66.3a2 2 0 002.1-2.1v-76.4a2 2 0 011.5-2l77.7-21.6a2 2 0 012.6 2v98a2 2 0 002.1 2H1895a2 2 0 012 2.2v97.6a2 2 0 01-2 2z"
                />
              </g>
            </svg>
          </router-link>
        </h1>
        <div class="menu-wrapper-right">
          <a
            href="#"
            class="menu-button "
            @click.prevent="toggle"
            :class="{ active: isActive }"
          >
            <span></span>
            <span></span>
          </a>
          <div class="social-sharing-wrapper">
            <a href="#" class="social-button">
              <svg
                width="31"
                height="31"
                viewBox="0 0 31 31"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="15.5" cy="15.5" r="15" stroke="black" />
                <circle cx="10.5" cy="15.5" r="2.5" fill="black" />
                <circle cx="20.5" cy="10.5" r="2.5" fill="black" />
                <circle cx="20.5" cy="20.5" r="2.5" fill="black" />
                <line
                  x1="11.3919"
                  y1="15.2665"
                  x2="19.8227"
                  y2="11.0112"
                  stroke="black"
                />
                <line
                  x1="11.1753"
                  y1="15.9568"
                  x2="19.6266"
                  y2="20.1714"
                  stroke="black"
                />
              </svg>
            </a>

            <social-sharing
              url=""
              title=""
              description=""
              quote=""
              hashtags=""
              inline-template
            >
              <div class="social-sharing">
                <network network="facebook">
                  <i class="fa fa-facebook"
                    ><svg
                      width="31"
                      height="31"
                      viewBox="0 0 31 31"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M29.7398 15.4086l.0001.0057c.0766 8.0779-6.5152 14.6245-14.5706 14.6245-8.0501 0-14.5705-6.5426-14.5705-14.6302C.5988 7.3211 7.1192.7785 15.1693.7785c8.0502 0 14.5706 6.5426 14.5705 14.6301z"
                        stroke="#222221"
                        stroke-width="1.1976"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M12.8539 24.6284h3.7524v-9.2977h2.5548l.2395-3.1259h-2.7943v-1.7634c0-.7213.1597-1.042.8782-1.042h1.996v-3.206h-2.5549c-2.7145 0-3.9919 1.2023-3.9919 3.5267v2.4847h-1.9161v3.1259h1.9161v9.2977h-.0798z"
                        fill="#222221"
                      /></svg
                  ></i>
                </network>
                <network network="whatsapp">
                  <i class="fa fa-whatsapp"
                    ><svg
                      width="31"
                      height="31"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.1694 30.4001C7.1192 30.4001.5988 23.8575.5988 15.77S7.1192 1.1398 15.1694 1.1398c8.0501 0 14.5706 6.5427 14.5706 14.6302s-6.5205 14.6301-14.5706 14.6301z"
                        stroke="#222221"
                        stroke-width="1.1976"
                        stroke-miterlimit="10"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M23.4724 15.3706c-.0798-4.4083-3.7524-7.935-8.1435-7.935-4.3912 0-7.984 3.4465-8.1436 7.7747v.3206c0 1.5229.3992 2.9657 1.1976 4.2481l-1.4371 4.4084 4.3911-1.5229c1.1976.6412 2.5549 1.042 3.992 1.042 4.5508 0 8.1435-3.687 8.1435-8.1756v-.1603zm-8.1435 7.0535c-1.4371 0-2.7146-.4008-3.7525-1.1222l-2.6346.8817.8782-2.5649c-.7984-1.1221-1.2774-2.4847-1.2774-4.0076v-.6412c.3193-3.4466 3.2734-6.1718 6.8661-6.1718 3.5927 0 6.5468 2.8054 6.8661 6.3321v.561c-.0798 3.6069-3.1935 6.7329-6.9459 6.7329z"
                        fill="#222221"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M19.0813 17.2125c-.2395-.0801-1.1976-.561-1.3572-.6412-.1597-.0802-.3194-.0802-.4791.0802-.1597.1603-.5589.6412-.6387.8015-.0798.1603-.2395.1603-.3992.0801-.1597-.0801-.8782-.3206-1.5968-.9618-.5588-.5611-1.0379-1.2023-1.1177-1.3626-.0799-.1603 0-.3206.0798-.4007.0799-.0802.1597-.2405.3194-.3207l.0798-.0801c.0798-.0802.0798-.1603.1597-.2405.0798-.1603 0-.2404 0-.3206-.0799-.0801-.479-1.1221-.6387-1.5229-.1597-.4007-.3194-.3206-.4791-.3206h-.3992c-.1596 0-.3193.0802-.5588.2405-.2396 0-.7186.5611-.7186 1.5229 0 .2404.0799.4809.0799.6412.2395.7214.6387 1.2824.7185 1.3626.0798.1603 1.3573 2.2442 3.4331 3.0458 2.0758.8015 2.0758.561 2.3952.4809.3992 0 1.1976-.4809 1.3572-.9619.1597-.4809.1597-.8816.0799-.9618l-.3194-.1603z"
                        fill="#222221"
                      /></svg
                  ></i>
                </network>
              </div>
            </social-sharing>
          </div>

          <div class="lang">
            <a
              class="active"
              data-lang="ro"
              href="#"
              v-on:click="switchLang('ro', $event)"
              >RO</a
            >
            <a data-lang="en" href="#" v-on:click="switchLang('en', $event)"
              >EN</a
            >
          </div>
        </div>
      </div>

      <div class="menu-content">
        <div class="menu-content-shape">
          <ul>
            <li>
              <router-link
                v-on:click.native="toggle(), scrollTo('#hero')"
                v-bind:to="'/'"
              >
                {{ menu.menu_home }}
              </router-link>
            </li>
            <li>
              <router-link
                v-on:click.native="toggle(), scrollTo('#our-projects')"
                v-bind:to="'/'"
              >
                {{ menu.menu_projects }}
              </router-link>
            </li>
            <li>
              <router-link
                v-on:click.native="toggle(), scrollTo('.about-us-shadow')"
                v-bind:to="'/'"
              >
                {{ menu.menu_about }}
              </router-link>
            </li>
            <li>
              <router-link
                v-on:click.native="toggle(), scrollTo('.footer-shadow')"
                v-bind:to="'/'"
              >
                {{ menu.menu_contact }}
              </router-link>
            </li>
            <li>
              <router-link
                v-on:click.native="toggle()"
                v-bind:to="'/smart-home'"
              >
                Smart Home
              </router-link>
            </li>
            <li>
              <div class="lang">
                <a
                  data-lang="ro"
                  href="#"
                  class="active"
                  v-on:click="toggle(), switchLang('ro', $event)"
                  >RO</a
                >
                <a
                  data-lang="en"
                  href="#"
                  v-on:click="toggle(), switchLang('en', $event)"
                  >EN</a
                >
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </fixed-header>
</template>

<script>
import { bus } from "../main";
import FixedHeader from "vue-fixed-header";
import axios from "axios";
import router from "../router";
// import AnchorRouterLink from "vue-anchor-router-link";

export default {
  components: { FixedHeader },
  data() {
    return {
      isActive: false,
      locale: "ro",
      menu: {
        menu_home: "",
        menu_projects: "",
        menu_aboutus: "",
        menu_contact: ""
      },
      strings: []
    };
  },
  methods: {
    scrollTo(el) {
      const element = document.querySelector(el);
      const offset = 100;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    },
    toggle() {
      const nav = document.querySelector(".menu-content").classList;
      nav.contains("active") ? nav.remove("active") : nav.add("active");
      // }
      this.isActive = !this.isActive;
    },
    switchLang(opt, e) {
      e.preventDefault();
      var el = e.target.parentNode;

      if (el && el.querySelector(".active")) {
        el.querySelector(".active").classList.remove("active");
        e.target.classList.add("active");
      } else {
        e.target.classList.add("active");
      }

      bus.$emit("lang", { lang: opt });
    },
    fetchData() {
      var self = this;

      // get settings (social urls)
      axios
        .get("https://api.riseapart.com/content?_limit=100", {
          headers: {
            "X-Locale": self.locale
          }
        })
        .then(function(res) {
          let stringsObj = res.data.data;
          let x;

          for (x = 0; x < stringsObj.length; x++) {
            let newObj = stringsObj[x];
            let newKey = Object.keys(newObj);
            self.strings[newObj[newKey].key] = newObj[newKey].value;
          }

          self.menu.menu_home = self.strings.meniu_acasa;
          self.menu.menu_about = self.strings.meniu_about;
          self.menu.menu_projects = self.strings.meniu_projects;
          self.menu.menu_contact = self.strings.meniu_contact;
        })
        .catch(function(error) {
          console.log("Error", error);
        });
    }
  },
  created() {
    // langCheck
    if (!this.$route.query.lang) {
      router.push({ query: { lang: "ro" } });
      this.locale = "ro";
    } else {
      this.locale = this.$route.query.lang;
      this.fetchData();
    }

    // lang switch
    bus.$on("lang", data => {
      this.locale = data.lang;
      router.push({ query: { lang: this.locale } });
      this.fetchData();
    });
  }
};
</script>

<style lang="scss">
@import "~@/assets/styles/_variables.scss";
@import "~@/assets/styles/_fonts.scss";

.menu-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: $color-light;
  z-index: 90;
  transform: translate3d(100vw, 0, 0);
  opacity: 0;
  transition: opacity 0.3s ease;

  &.active {
    opacity: 1;
    transform: translate3d(0, 0, 0);

    .menu-content-shape {
      transform: translate3d(0, 0, 0);
    }

    ul li {
      opacity: 1;
      transform: translate3d(0, 0, 0);

      // &:nth-child(1) {
      //   transition-delay: 0.3s;
      // }
      // &:nth-child(2) {
      //   transition-delay: 0.35s;
      // }
      // &:nth-child(3) {
      //   transition-delay: 0.4s;
      // }
      // &:nth-child(4) {
      //   transition-delay: 0.45s;
      // }
    }
  }

  &-shape {
    display: block;
    width: 100vw;
    height: 100vh;
    background-color: $color-dark;
    z-index: 90;
    transform: translate3d(120vw, 200px, 0);
    transition: transform 0.3s ease 0.4s;
    -webkit-mask-image: url("~@/assets/mask-menu.png");
    mask-image: url("~@/assets/mask-menu.png");
    -webkit-mask-position: right 40px;
    mask-position: right 40px;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-size: 120vw 90vh;
    mask-size: 120vw 90vh;

    @media screen and (max-height: 800px) {
      -webkit-mask-size: 120vw 110vh;
      mask-size: 120vw 110vh;
    }

    ul {
      display: flex;
      flex-direction: column;
      text-align: left;
      justify-content: flex-start;
      width: 30vw;
      height: 100vh;
      margin: 0 auto;
      padding-top: 25vh;

      li {
        display: block;
        margin: 10px 0;
        font-family: "gopherbold";
        font-style: normal;
        font-size: 50px;
        line-height: 63px;
        letter-spacing: 0.2em;
        text-transform: uppercase;
        color: $color-light;
        opacity: 0;
        transform: translate3d(0, 10px, 0);
        transition: color 0.3s ease;

        &:hover {
          cursor: pointer;
          color: $color-yellow;
        }

        a {
          color: inherit;
          text-decoration: none;
        }

        .lang {
          display: none;
        }
      }
    }
  }
}

.menu {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  margin: 0 auto;
  z-index: 100;
  transition: all 0.3s ease;

  &.vue-fixed-header--isFixed {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    width: 100%;
    height: 85px;
    background-color: $color-light;
    z-index: 300;

    .logo-cta {
      transform: scale(0.8);
    }

    .menu-wrapper {
      transform: translate(0px, -20px);
    }
  }

  &-wrapper {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: calc(1440px - 100px);
    margin: 23px auto;
    transition: all 0.3s ease;
    z-index: 100;

    .logo-cta {
      display: block;
      width: 100px;
      height: 60px;
      transition: all 0.3s ease;
    }

    &-right {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
    }
  }

  &-button {
    display: block;
    width: 33px;
    height: 19px;

    &.active {
      span {
        transform: translate3d(0, 7px, 0) rotate(45deg);

        + span {
          transform: translate3d(0, -6px, 0) rotate(-45deg);
        }
      }
    }

    span {
      display: block;
      width: 33px;
      height: 6px;
      background: $color-dark;
      border-radius: 60px;
      transition: transform 0.3s ease;

      + span {
        margin-top: 7px;
      }
    }
  }

  .social-button {
    display: block;
    line-height: 11px;

    svg {
      fill: $color-light;
    }

    svg,
    cirle,
    line {
      transition: all 0.3s ease;
    }
  }

  .social-sharing-wrapper {
    position: relative;
    width: 33px;
    height: 75px;
    margin-left: 32px;
    transform: translate(0, 20px);
    // @media (hover: hover) {
    &:hover {
      .social-button {
        svg {
          fill: $color-dark;

          circle {
            &:not(:first-child) {
              fill: $color-light;
            }
          }

          line {
            stroke: $color-light;
          }
        }
      }

      .social-sharing {
        height: 75px;
        opacity: 1;
      }
    }
    // }
  }

  .social-sharing {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    transform: translate3d(0, 38px, 0);
    height: 0;
    opacity: 0;
    overflow: hidden;
    transition: opacity 0.3s ease;

    span:hover {
      cursor: pointer;
    }

    span {
      svg {
        fill: $color-light;
      }

      &:hover {
        svg {
          fill: $color-dark;

          path + path {
            fill: $color-light;
          }
        }
      }
    }
  }

  .lang {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: -4px 0 0 17px;
    transform: translate(0, 20px);

    &:hover {
      a {
        opacity: 1;
      }
    }

    a {
      display: block;
      width: 30px;
      height: 30px;
      padding: 5px 6px;
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 18px;
      text-transform: uppercase;
      text-decoration: none;
      border: 1px solid $color-dark;
      border-radius: 30px;
      color: $color-dark;
      order: 2;
      opacity: 0;

      &.active {
        order: 1;
        opacity: 1;
        margin-bottom: 10px;
      }

      &:hover {
        cursor: pointer;
        color: $color-light;
        background: $color-dark;
        opacity: 1;

        + a {
          opacity: 1;
        }
      }

      + a {
        transition: opacity 0.3s ease;
      }
    }
  }
}

// @media screen and (max-width: 1280px) {
//   .menu {
//     &.vue-fixed-header--isFixed {
//       height: 65px;
//
//       .menu-wrapper {
//         transform: translate(0, 0);
//       }
//     }
//   }
//
//   .menu-content {
//     // height: calc(100vh - 65px);
//     height: 100vh;
//
//     &-shape {
//       -webkit-mask-size: 1920px 710px;
//       mask-size: 1920px 710px;
//
//       ul {
//         width: 60vw;
//
//         li {
//           font-family: "gopherbold";
//           font-size: 33px;
//           line-height: 43px;
//           display: flex;
//           align-items: center;
//           letter-spacing: 0.2em;
//           color: $color-light;
//         }
//       }
//     }
//
//     &.active {
//       transform: translate3d(0, 0, 0);
//     }
//   }
//
//   .menu-wrapper {
//     position: relative;
//     display: flex;
//     flex-direction: row;
//     justify-content: space-between;
//     align-items: center;
//     width: 80vw;
//     max-width: 80vw;
//     margin: 20px auto;
//     transition: all 0.3s ease;
//     z-index: 100;
//
//     .logo-cta {
//       width: 55px;
//       height: 31px;
//     }
//
//     .menu-button {
//       width: 23px;
//       height: 14px;
//
//       &.active {
//         span {
//           transform: translate3d(0, 4px, 0) rotate(45deg);
//
//           + span {
//             transform: translate3d(0, -7px, 0) rotate(-45deg);
//           }
//         }
//       }
//
//       span {
//         width: 23px;
//         height: 4px;
//       }
//     }
//
//     .social-sharing-wrapper {
//       display: none;
//     }
//
//     .lang {
//       display: none;
//     }
//   }
// }

@media screen and (max-width: 1200px) {
  .menu {
    &.vue-fixed-header--isFixed {
      height: 65px;

      .menu-wrapper {
        transform: translate(0, 0);
      }
    }
  }

  .menu-content {
    // height: calc(100vh - 65px);
    height: 100vh;

    &-shape {
      -webkit-mask-size: 1920px 940px;
      mask-size: 1920px 940px;
      -webkit-mask-position: 50vw 0;
      mask-position: 50vw 0;
      transition: -webkit-mask-position 0.4s ease 0.2s;

      ul {
        width: 60vw;
        padding-top: 30vh;

        li {
          display: flex;
          align-items: center;
          margin: 6px 0;
          font-family: "gopherbold";
          font-size: 43px;
          line-height: 53px;
          letter-spacing: 0.2em;
          color: $color-light;

          .lang {
            margin: 30px 0 0;
            letter-spacing: 0;

            a {
              padding: 7px 6px;
              font-size: 16px;
              border-color: $color-light;
              color: $color-light;
              opacity: 1;

              &.active {
                background: $color-light;
                color: $color-dark;
                margin: 0;
              }
            }
          }
        }
      }
    }

    &.active {
      transform: translate3d(0, 0, 0);

      .menu-content-shape {
        -webkit-mask-position: -100vw 35px;
        mask-position: -100vw 35px;
      }
    }
  }

  .menu-wrapper {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 80vw;
    max-width: 80vw;
    margin: 20px auto;
    transition: all 0.3s ease;
    z-index: 100;

    .logo-cta {
      width: 55px;
      height: 31px;
    }

    .menu-button {
      width: 23px;
      height: 14px;

      &.active {
        span {
          transform: translate3d(0, 4px, 0) rotate(45deg);

          + span {
            transform: translate3d(0, -7px, 0) rotate(-45deg);
          }
        }
      }

      span {
        width: 23px;
        height: 4px;
      }
    }

    .social-sharing-wrapper {
      display: none;
    }

    .lang {
      display: none;
    }
  }
}

@media screen and (max-width: 760px) {
  .menu {
    &.vue-fixed-header--isFixed {
      height: 65px;

      .menu-wrapper {
        transform: translate(0, 0);
      }
    }
  }

  .menu-content {
    // height: calc(100vh - 65px);
    height: 100vh;

    &-shape {
      -webkit-mask-size: 1920px 940px;
      mask-size: 1920px 940px;
      -webkit-mask-position: 50vw 0;
      mask-position: 50vw 0;
      transition: -webkit-mask-position 0.4s ease 0.2s;

      ul {
        width: 70vw;
        padding-top: 26vh;

        li {
          display: flex;
          align-items: center;
          margin: 10px 0;
          font-family: "gopherbold";
          font-size: 28px;
          line-height: 40px;
          letter-spacing: 0.2em;
          color: $color-light;

          .lang {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            margin: 30px 0 0 0;
            letter-spacing: 0;

            a {
              font-size: 14px;
              padding: 5px;
              border-color: $color-light;
              color: $color-light;

              &.active {
                margin-right: 20px;
                background: $color-light;
                color: $color-dark;
              }

              + a {
                margin: 0;
                opacity: 1;
              }
            }
          }
        }
      }
    }

    &.active {
      transform: translate3d(0, 0, 0);

      .menu-content-shape {
        -webkit-mask-position: -200vw 35px;
        mask-position: -200vw 35px;
      }
    }
  }

  .menu-wrapper {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 90vw;
    max-width: 90vw;
    margin: 20px auto;
    transition: all 0.3s ease;
    z-index: 100;

    .logo-cta {
      width: 55px;
      height: 31px;
    }

    .menu-button {
      width: 23px;
      height: 14px;

      &.active {
        span {
          transform: translate3d(0, 4px, 0) rotate(45deg);

          + span {
            transform: translate3d(0, -7px, 0) rotate(-45deg);
          }
        }
      }

      span {
        width: 23px;
        height: 4px;
      }
    }

    .social-sharing-wrapper {
      // display: none;
      display: block;
      height: 33px;
      transform: translate(0, 0);

      .social-button:focus {
        // opacity: 0;
        //
        // + .social-sharing {
        //   flex-direction: row;
        //   justify-content: space-between;
        //   width: 74px;
        //   height: 37px;
        //   left: -12px;
        //   transform: translate3d(0, 0, 0);
        //   opacity: 1;
        //   z-index: 90;
        //
        //   span + span {
        //     margin-left: 10px;
        //   }
        // }
      }
    }

    .lang {
      // display: none;
    }
  }
}
</style>
